import React from "react"
import Img from "gatsby-image"
import { FormattedMessage, useIntl } from "react-intl"
import { useStaticQuery, graphql } from "gatsby"
import { langId } from "../languages"

const QrcodeFrame = ({ titleKey, fluidImg, type }) => {
  const Images = useStaticQuery(graphql`
    query {
      linkReitWechat: file(
        relativePath: {
          eq: "images/link-reit-channel-823-q2-2020-expands-digital-presence-wechat.png"
        }
      ) {
        ...fragmentsFluidImage
      }

      linkReitWeibo: file(
        relativePath: {
          eq: "images/link-reit-channel-823-q2-2020-expands-digital-presence-weibo.png"
        }
      ) {
        ...fragmentsFluidImage
      }
    }
  `)
  const intl = useIntl()
  const defaultImgage = type
    ? type === "wechat"
      ? Images.linkReitWechat.childImageSharp.fluid
      : Images.linkReitWeibo.childImageSharp.fluid
    : fluidImg

  const defaultTitleKey = type
    ? type === "wechat"
      ? langId.LINKS_WECHAT_PAGE
      : langId.LINKS_WEIBO_PAGE
    : titleKey

  return (
    <div className="qrcode-frame">
      <div className="qrcode-frame__img">
        <Img
          fluid={defaultImgage}
          alt={intl.formatMessage({ id: defaultTitleKey })}
          title={intl.formatMessage({ id: defaultTitleKey })}
        ></Img>
      </div>
      <h2 className="qrcode-frame__title">
        <FormattedMessage id={defaultTitleKey}></FormattedMessage>
      </h2>
    </div>
  )
}

export default QrcodeFrame
